import { Config } from "../../../api/config";
//API keys
export var SpareIssuesKeys = {
    Paging: "spareIssuePaging",
    SearchDetails: "searchDetails",
    JobcardDetails: "jobcardDetailsByIdGet",
    WarehouseList: 'warehouseListGet',
    TechnicianList: 'technicianListGet',
    ServiceAdvisorList: 'serviceAdvisorListGet',
    CustomerAssociationDetails: 'customerDetails',
    PartDetails: 'partDetailsGet',
    LocationDetails: "locationDetailGet",
    GetSerialNumber: 'getSerialNumbers',
    SearchByTypeList: "getSearchByTypeList",
    SpareIssueDataFromJobcard: 'getSpareIssueFromJobcard',
    PartIssueDetails: 'partIssueDetails',
    Create: 'spareIssueCreate',
    CheckSerialNumber: 'checkSerialNumber',
    Status: 'statusListGet',
    Installbasedetails: 'Installbasedetails'
};
// API urls
export var getSpareIssueGeneralDetails = "".concat(Config.baseURL, "spareIssuesGeneralDetails/Get");
export var getProductIssueList = "".concat(Config.baseURL, "ProductIssue/Paging");
export var getFilterTypeList = "".concat(Config.baseURL, "FilterType/List");
export var getSpareIssueSearchDetail = "".concat(Config.baseURL, "JobCard/GetSearchDetails");
export var getWarehouseList = "".concat(Config.baseURL, "Warehouse/ByTenant");
export var technicianListAPI = "".concat(Config.baseURL, "OrganizationEmployee/Technicians");
export var serviceAdvisorListAPI = "".concat(Config.baseURL, "IdentityOrganizationAccessRight/GetServiceAdvisor");
export var getCustomerByIdAPI = function (id) { return "".concat(Config.baseURL, "Customer/").concat(id, "/Get"); };
export var getPartDetailsAPI = "".concat(Config.baseURL, "JobCardDetail/PartsByJCForSpareIssue");
export var getSerialNumberDetails = "".concat(Config.baseURL, "Inventory/VoilationByRemovalStrategy");
export var getLocationDetailsAPI = "".concat(Config.baseURL, "Inventory/GetAvailableQtyByWarehouse");
export var createSpareIssueFromJobcardAPI = "".concat(Config.baseURL, "ProductIssue/CreateProductIssueByJC");
export var getSpareIssueDetailsAPI = function (id) { return "".concat(Config.baseURL, "ProductIssue/").concat(id, "/Get"); };
export var spareIssueJobCardDetailsAPI = "".concat(Config.baseURL, "ProductIssue/JobCardDetails");
export var spareIssueCreateAPI = "".concat(Config.baseURL, "ProductIssue/CreateProductIssue");
export var CheckSerialNumberAvailable = "".concat(Config.baseURL, "ProductInventoryDefaultConfiguration/CheckDefaultTrackingType");
export var getJobCardDetailAPI = "".concat(Config.baseURL, "ProductIssue/GetJobCardDetails");
//constants
export var visibleColumns = {
    DocumentNo: 'Document number',
    RequestedDateTime: 'Document date',
    JobCardNo: 'Job card No.',
    VinNo: 'VIN',
    RegistrationNo: 'Registration No.',
    FloorSupervisorName: 'Floor Supervisor',
    TechnicianName: 'Technician',
    TotalPartsCount: 'Total Parts Count',
    TotalAvailableQuantity: 'Total Parts Quantity',
    TotalIssueQuantity: 'Total Issued Quantity',
    //CreatedByGivenName: 'Issued By',
    ProductName: 'Product Name',
    BranchName: 'Branch',
    StatusName: 'Status'
};
export var viewTypeOptions = [{
        id: 1,
        name: "My spare issue"
    }, {
        id: 2,
        name: "All spare issue"
    }];
export var EKeys = {
    Customer: "Customer",
    ServiceAdvisor: "ServiceAdvisor",
    Technician: "Technician",
    FloorSupervisor: "FloorSupervisor",
    Vehicle: "Vehicle"
};
export var APIKeys = [SpareIssuesKeys.JobcardDetails, SpareIssuesKeys.PartDetails, SpareIssuesKeys.CustomerAssociationDetails, SpareIssuesKeys.SearchDetails, SpareIssuesKeys.PartIssueDetails, SpareIssuesKeys.GetSerialNumber, SpareIssuesKeys.Create, SpareIssuesKeys.Status, SpareIssuesKeys.SearchByTypeList, SpareIssuesKeys.LocationDetails];
export var enumKeys = {
    DefaultInventoryTrackingType: "Serialized"
};
export var SpareIssueStatusEnum = /*#__PURE__*/ function (SpareIssueStatusEnum) {
    SpareIssueStatusEnum["Issued"] = "Issued";
    SpareIssueStatusEnum["PartiallyReturned"] = "Partially returned";
    SpareIssueStatusEnum["Returned"] = "Returned";
    SpareIssueStatusEnum["Cancelled"] = "Cancelled";
    SpareIssueStatusEnum["Closed"] = "Closed";
    return SpareIssueStatusEnum;
}({});
export var SEMandatoryFields = {
    'IssueQuantity': 'IssueQuantity'
};
export var defaultState = {
    skip: 0,
    take: 10
};
